export const COLUMN_OPTIONS = [
  {
    value: "InStateInd",
    label: "InStateInd",
    schema: "fact",
    table: "studentDetails",
  },
  {
    value: "AcademicInterestApp_ClientCode",
    label: "AcademicInterestApp_ClientCode",
    schema: "dimension",
    table: "dimAcademicInterest",
  },
  {
    value: "Academic_Interest_App_Category",
    label: "Academic_Interest_App_Category",
    schema: "dimension",
    table: "dimAcademicInterest",
  },
];
